import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

import { Role } from "../../models/administration/role.model";

@Injectable({ providedIn: "root" })
export class RoleService {

  private service = "RoleService";

  public godUserRole: Role = {
    id: 1,
    name: 'God User',
    description: 'Having access to all data and all pages without any restriction',
    disciplineId: null,
    isEditable: false,
    memberCount: 0
  };

  public dnaAdminUserRole: Role = {
    id: 2,
    name: 'DNA Admin User',
    description: 'Having access to all DNAs of a client rather than only assigned DNAs',
    disciplineId: null,
    isEditable: false,
    memberCount: 0
  };

  public freeDesignAssistantUserRole: Role = {
    id: 6,
    name: 'Free Design Assistant Client',
    description: 'Having limited functionality on Design Assistant',
    disciplineId: null,
    isEditable: false,
    memberCount: 0
  };

  public portalUserRole: Role = {
    id: 3,
    name: 'Portal User',
    description: 'Normal user role with no extra facilities',
    disciplineId: null,
    isEditable: false,
    memberCount: 0
  };

  constructor(private http: HttpClient) {
  }

  public listRoles() {
    return this.http.get<Role[]>(`api/${this.service}/list`, { responseType: "json" });
  }
  public insert(role: Role) {
    return this.http.post<boolean>(`api/${this.service}/insert`, role, { responseType: "json" });
  }
  public update(role: Role) {
    return this.http.put<Role>(`api/${this.service}/update`, role, { responseType: "json" });
  }
  public delete(id: number) {
    return this.http.delete<any>(`api/${this.service}/delete/${id}`, { responseType: "json" });
  }
}
